<h1 mat-dialog-title>
  {{(data.isNewPrinter ? 'administration.printers.add' : 'administration.printers.edit') | translate}}
  <div style="float: right">
    <span *ngIf="data.isNewPrinter">
      <fa-layers [fixedWidth]="true">
        <fa-icon [icon]="faPrint" transform="left-3"></fa-icon>
        <fa-icon [icon]="faPlus" transform="shrink-7 up-4 right-8"></fa-icon>
      </fa-layers>
    </span>
    <span *ngIf="!data.isNewPrinter">
      <fa-layers [fixedWidth]="true">
        <fa-icon [icon]="faPrint" transform="left-3 up-2"></fa-icon>
        <fa-icon [icon]="faPen" transform="shrink-7 down-3 right-8"></fa-icon>
      </fa-layers>
    </span>
  </div>
</h1>
<mat-divider></mat-divider>
<form name="printerForm" [formGroup]="printerFormGroup">
  <div mat-dialog-content>

    <mat-form-field appearance="outline">
      <mat-label>{{'administration.printers.shop' | translate}}</mat-label>
      <mat-select name="shopSelect" [formControl]="shopSelectFormControl" [disableOptionCentering]="true">
        <mat-option *ngFor="let shop of data.shopList" [value]="shop.id">
          {{shop.shopNumber}} - {{ shop.shopName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" color="primary">
      <mat-label>{{'administration.printers.name' | translate}}</mat-label>
      <input matInput name="printerName" [formControl]="printerNameFormControl" autocomplete="off" required>
      <mat-error *ngIf="printerNameFormControl.hasError('required')">
        {{'common.field-required' | translate}}
      </mat-error>
    </mat-form-field>

    <div class="row">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>{{'administration.printers.ip-address' | translate}}</mat-label>
        <input matInput name="printerIp" [formControl]="printerIpFormControl" autocomplete="off" required addressIpMask>
        <mat-error *ngIf="printerIpFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="port" appearance="outline" color="primary">
        <mat-label>{{'administration.printers.port' | translate}}</mat-label>
        <input matInput name="printerPort" [formControl]="printerPortFormControl" autocomplete="off" [numberMask]="true"
          maxlength="4">
        <mat-error *ngIf="printerPortFormControl.hasError('required')">
          {{'common.field-required' | translate}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="is-active">
      <mat-slide-toggle [formControl]="isActiveFormControl">{{'common.active' | translate}}
      </mat-slide-toggle>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()" type="button" color="warn">{{'common.cancel' | translate}}</button>
    <button mat-button (click)="onOkClick()" type="submit" [mat-dialog-close]="data"
      [disabled]="!printerFormGroup.valid" color="accent">{{'common.save' | translate}}</button>
  </div>
</form>